module.exports = __webpack_public_path__ + "media/src/images/payment_systems/invoice_en-ea71badb1031d5246000aaa86d691769.png";